module.exports = __webpack_public_path__ + "img/promotion-card.f3897a0e.png";